import { render } from "./UserAuth.vue?vue&type=template&id=fd584830&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=fd584830&scoped=true&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd584830"]])

export default __exports__